import type { ContractingCompaniesService } from "./service";
import type {
  IDeleteContractingCompanyRequest,
  IGetContractingCompaniesRequest,
  IGetContractingCompanyByIdRequest,
  IUpsertContractingCompanyInput,
} from "./types";
import { BaseRepository } from "../BaseRepository";
import type { IPaginated, IRepositoryOptions } from "@/types/common";
import type { AxiosRequestConfig } from "axios";
import type { IContractingCompany } from "@/types/companies-contractors";

export class ContractingCompaniesRepository extends BaseRepository {
  constructor(
    private readonly service: ContractingCompaniesService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async getAll(
    p: IGetContractingCompaniesRequest,
    c?: AxiosRequestConfig,
  ): Promise<IPaginated<IContractingCompany>> {
    const response = await this.handleRequest(this.service.getAll, p, c);
    return response.data;
  }

  async getCompanyDetails(
    p: IGetContractingCompanyByIdRequest,
    c?: AxiosRequestConfig,
  ): Promise<IContractingCompany> {
    const response = await this.handleRequest(
      this.service.getCompanyDetails,
      p,
      c,
    );
    return response.data;
  }

  async upsertCompany(
    p: IUpsertContractingCompanyInput,
    c?: AxiosRequestConfig,
  ): Promise<IContractingCompany> {
    const p2 = new FormData();

    p2.append(
      "contractingCompany",
      new Blob([JSON.stringify(p.contractingCompany)], {
        type: "application/json",
      }),
    );

    if (p.logo) {
      p2.append("logo", p.logo[0]);
    }

    const response = await this.handleRequest(
      this.service.upsertCompany,
      p2,
      c,
    );
    return response.data;
  }

  async deleteCompany(
    p: IDeleteContractingCompanyRequest,
    c?: AxiosRequestConfig,
  ): Promise<void> {
    const response = await this.handleRequest(this.service.deleteCompany, p, c);
    return response.data;
  }
}
